/*
 * Copyright (C) 2015 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './batchrangepicker.tpl.html';

angular
  .module('shared.batchrangepicker', ['shared.backupPicker'])
  /**
   * Controller for the BatchRangePicker template.
   */
  .controller(
    'BatchRangePickerCtrl',
    function ($scope, $rootScope, $filter, $timeout, batchUtils, BasicBatchPickerStore, ALERT_EVENTS, SOBJECT_STATE) {
      var i18n = $filter('i18n');

      $scope.stateValues = [SOBJECT_STATE.UPDATED, SOBJECT_STATE.DELETED, SOBJECT_STATE.NEW, SOBJECT_STATE.UNCHANGED];
      $scope.stateLabels = [i18n('UPDATED'), i18n('DELETED'), i18n('CREATED'), i18n('UNCHANGED')];

      // Create two stores for each of the date pickers
      $scope.pickerStoreMin = new BasicBatchPickerStore();
      $scope.pickerStoreMax = new BasicBatchPickerStore();

      /**
       * Utility to emit error if invalid date is selected.
       *
       * @param {object} pickerStore - the PickerStore object.
       */
      $scope.invalidDate = function (pickerStore) {
        var removeInvalidOutline = function () {
          pickerStore.invalidSelectedDate = false;
        };

        pickerStore.invalidSelectedDate = true;
        $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, i18n('INVALID_DATE'));
        $timeout(removeInvalidOutline, 10000);
      };

      // If we have values in $scope.startBatchId and $scope.endBatchId we want to get those batches.
      // Otherwise default to latest batch and previous
      if ($scope.startBatchId && $scope.endBatchId) {
        $scope.pickerStoreMin.getBatch($scope.startBatchId);
        $scope.pickerStoreMax.getBatch($scope.endBatchId);
      } else {
        batchUtils.getBatches(2, true).then(
          function (batches) {
            if (batches.rows.length > 1) {
              if ($scope.browseMode) {
                $scope.pickerStoreMin.batchObject = batches.rows[0];
              } else {
                $scope.pickerStoreMin.batchObject = batches.rows[1];
              }
              $scope.pickerStoreMax.batchObject = batches.rows[0];
            } else if (batches.count === 1 && $scope.browseMode) {
              $scope.pickerStoreMin.batchObject = batches.rows[0];
              $scope.pickerStoreMax.batchObject = batches.rows[0];
            }
          },
          function () {
            $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, i18n('ERROR_OCCURRED'));
          }
        );
      }

      // Watch the values of the two basic batch pickers and update the range values.
      $scope.$watch(
        function () {
          return $scope.pickerStoreMin.batchObject.batchId;
        },
        function (newVal) {
          if (newVal) {
            // Reset the invalidSelectedDate flag every time date is changed
            if ($scope.pickerStoreMin.lastValidBatch && newVal !== $scope.pickerStoreMin.lastValidBatch.batchId) {
              $scope.pickerStoreMin.invalidSelectedDate = false;
            }
            $scope.startBatchId = newVal;
            $scope.startBatchDate = $scope.pickerStoreMin.batchObject.date;
          }
        }
      );

      $scope.$watch(
        function () {
          return $scope.pickerStoreMax.batchObject.batchId;
        },
        function (newVal) {
          if (newVal) {
            // Reset the invalidSelectedDate flag every time date is changed
            if ($scope.pickerStoreMax.lastValidBatch && newVal !== $scope.pickerStoreMax.lastValidBatch.batchId) {
              $scope.pickerStoreMax.invalidSelectedDate = false;
            }
            $scope.endBatchId = newVal;
            $scope.endBatchDate = $scope.pickerStoreMax.batchObject.date;
          }
        }
      );

      // Watch for external changes to the selected batches. The search controller may be resetting the batches.
      $scope.$watch(
        () => $scope.startBatchId,
        (newVal, oldVal) => {
          if (newVal !== oldVal && newVal !== $scope.pickerStoreMin.batchObject.batchId) {
            $scope.pickerStoreMin.getBatch(newVal);
          }
        }
      );

      $scope.$watch(
        () => $scope.endBatchId,
        (newVal, oldVal) => {
          if (newVal !== oldVal && newVal !== $scope.pickerStoreMax.batchObject.batchId) {
            $scope.pickerStoreMax.getBatch(newVal);
          }
        }
      );
    }
  )
  /**
   * The directive for the batch range picker view. The storeName attribute should be
   * the name of the Store factory implementation to provide data to the picker.
   */
  .directive('batchrangepicker', function () {
    return {
      templateUrl: 'shared/batchrangepicker/batchrangepicker.tpl.html',
      scope: {
        // The id selected start batch. We will set this when the user picks a batch from the min picker, or it can be
        // set by the caller and we'll display that batch in the min picker.
        startBatchId: '=',
        // The date of the selected start batch. We will set this whenever the batch in the min picker changes.
        startBatchDate: '=',
        // The caller can set this true if the min picker is to be highlighted as modified.
        startBatchModified: '=',
        // The id selected end batch. We will set this when the user picks a batch from the max picker, or it can be
        // set by the caller and we'll display that batch in the max picker.
        endBatchId: '=',
        // The date of the selected end batch. We will set this whenever the batch in the max picker changes.
        endBatchDate: '=',
        // The caller can set this true if the max picker is to be highlighted as modified.
        endBatchModified: '=',
        // The selected object state. We will set this when the user picks a new state, or it can be set by the caller
        // and we'll display that state in the dropdown.
        state: '=',
        // The caller can set this true if the state dropdown is to be highlighted as modified.
        stateModified: '=',
        // A function to be called when a date selected in one of the batch pickers is invalid. I don't think this is
        // used.
        invalidDate: '&',
        // The function to be called when a value is selected. The function is passed the value.
        onValueSelected: '&',
        // The function to be called when a value is unselected. The function is passed the value.
        // This only happens if selectType === 'multi'
        onValueUnselected: '&',
        browseMode: '='
      },
      controller: 'BatchRangePickerCtrl'
    };
  });
